define('lq/events/actions/labelImageCommand',[
    'lq/events/actions/eventAction'
], function (EventAction) {
    'use strict';

    function LabelImageCommand(eventData, eventArg) {
    	EventAction.call(this, eventData, eventArg);
    }

    EventAction.extend(LabelImageCommand, EventAction);

    LabelImageCommand.typeName = 'LabelImageCommand';

    LabelImageCommand.prototype.getBatchType = function () {
    	return EventAction.COMMAND_BATCH;
    };

    LabelImageCommand.prototype.createEventActionRequest = function () {
    	return {
            eventActionType: 'LabelImage',
    		command: this.eventData.command
    	};
    };

    return LabelImageCommand;
});
